import React from 'react';
import { toDateString } from '../../../utils/date';

const S = {
  wrap: { padding: 14, display: 'flex', flexDirection: 'column', gap: 10 },
  row: {
    border: '1px solid var(--border)',
    borderRadius: 10,
    background: 'var(--bg-subtle)',
    padding: 12,
    display: 'grid',
    gridTemplateColumns: 'minmax(120px, 0.8fr) minmax(180px, 1.2fr) minmax(180px, 1.2fr)',
    gap: 10,
    alignItems: 'center',
  },
  endDate: { fontSize: 12, fontWeight: 950, color: '#64748b' },
  names: { minWidth: 0 },
  main: { fontSize: 13, fontWeight: 950, color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  sub: { marginTop: 3, fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.35 },
  rule: { fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.4, minWidth: 0 },
  note: { marginTop: 3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  empty: { padding: 22, textAlign: 'center', color: 'var(--text-muted)', fontSize: 12 },
};

function fmtDate(value) {
  return value ? toDateString(value) : '';
}

function periodText(row) {
  return `${fmtDate(row.start_date)} ~ ${row.end_date ? fmtDate(row.end_date) : '진행중'}`;
}

function latestRule(row) {
  return [...(row.billing_rules || [])].sort((a, b) => String(b.effective_from || '').localeCompare(String(a.effective_from || '')))[0] || null;
}

function ruleText(row) {
  const rule = latestRule(row);
  if (!rule) return '급여 조건 없음';
  const salary = rule.salary_enabled ? `${Number(rule.monthly_salary || 0).toLocaleString('ko-KR')}원` : '급여 제외';
  const source = rule.incentive_source || (rule.incentive_enabled === false ? 'none' : 'direct');
  const incentive = source === 'incentive_total'
    ? '인센티브 관리 금액'
    : source === 'none'
      ? '인센티브 제외'
      : `${Number(rule.incentive_base_included_count || 0) > 0 ? `${Number(rule.incentive_base_included_count || 0).toLocaleString('ko-KR')}장 포함 · ` : ''}${Number(rule.incentive_unit_price || 0).toLocaleString('ko-KR')}원/장`;
  return `${rule.effective_from || '-'}부터 · ${salary} · ${incentive}`;
}

export function AssignmentHistoryPanel({ assignments = [] }) {
  const rows = [...assignments]
    .filter((row) => row.end_date)
    .sort((a, b) => (
      String(b.end_date || '').localeCompare(String(a.end_date || ''))
      || String(b.start_date || '').localeCompare(String(a.start_date || ''))
      || String(a.marketer_name || '').localeCompare(String(b.marketer_name || ''), 'ko')
    ));

  if (!rows.length) return <div style={S.empty}>끝난 배정이 없습니다.</div>;

  return (
    <div style={S.wrap}>
      {rows.map((row) => (
        <div key={row.id} style={S.row}>
          <div>
            <div style={S.endDate}>{fmtDate(row.end_date)} 종료</div>
            <div style={S.sub}>{periodText(row)}</div>
          </div>
          <div style={S.names}>
            <div style={S.main}>{row.marketer_name || '마케터'} → {row.consultant_name || '1:1 직원'}</div>
            {row.notes && <div style={{ ...S.sub, ...S.note }} title={row.notes}>{row.notes}</div>}
          </div>
          <div style={S.rule}>{ruleText(row)}</div>
        </div>
      ))}
    </div>
  );
}
